import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { ContainerButtonPlay } from '../../Utils/Button';
import { IMiniCursoFit12Response, IMiniCursoResponse } from '../../Interfaces/IMiniCurso';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
// import ScrollToBottomFab from '../FAB/ScrollToBottomFab';

import { grayPlayButton } from '../../Shared/Images';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import atrasIcon from '../../Shared/Images/atras-icon.png';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from '../Main/styles/resultadosPC.module.css';
import { FormControl, MenuItem, Select } from '@mui/material';


interface Props {
  currentPosition: number;
  setCurrentPosition: Dispatch<SetStateAction<number>>;
  weeks: IMiniCursoFit12Response[];
  currentWeek: IMiniCursoResponse[];
  weekPosition?: number;
  setWeekPosition?: Dispatch<SetStateAction<number>>;
}

const Fit12PagePC = ({ currentPosition, setCurrentPosition, weeks, currentWeek, weekPosition, setWeekPosition } : Props) => {

  const [mostrarVideo, setMostrarVideo] = useState(false);
  const [dataMiniCurso, setDataMiniCurso] = useState<IMiniCursoResponse>();
  // const [currentPosition, setCurrentPosition] = useState<number>(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (currentWeek && currentWeek.length > 0) {
      setDataMiniCurso({
        descripcion:      currentWeek[currentPosition].descripcion,
        miniCursoVideoID: currentWeek[currentPosition].miniCursoVideoID,
        titulo:           currentWeek[currentPosition].titulo,
        urlVimeoHLS:      currentWeek[currentPosition].urlVimeoHLS,
        portada:          currentWeek[currentPosition].portada,
        orden:            currentWeek[currentPosition].orden,
      });
    }
  }, [currentPosition, currentWeek])

  function retrocederVideo () {
    if(currentPosition !== 0) {
      if(currentWeek[currentPosition - 1]) {
        setCurrentPosition( c => c - 1 );
      }
    }
  }
  function avanzarVideo () {
    if(currentPosition + 1 !== currentWeek.length) {
      if(currentWeek[currentPosition + 1]) {
        setCurrentPosition( c => c + 1 );
      }
    }
  }

  return (
    <div>
      <div>
        <div className="p-4 flex flex-col items-center justify-center gap-4">
          <div className="h-[1vh] w-full"></div>
          <div
            className="flex items-center justify-start w-[90%] m-auto"
            style={{ gap: '1rem', paddingLeft: '1rem' }}
          >
            <img
              onClick={() => navigate('/')}
              src={atrasIcon}
              style={{ width: '35px', height: '25px', cursor: 'pointer' }}
            />
            <p
              style={{ margin: '0', fontWeight: 'bold', fontSize: '1.25rem' }}
              className="title"
            >
              Programa Fit 12
            </p>
          </div>
          <div className="flex  gap-2 items-end pb-2">
            {/* <div className="p-[6px] rounded bg-black text-white">
              <p className="text-lg font-bold p-0 m-0">Semana:</p>
            </div> */}
            <FormControl size="medium" >
              <Select
                labelId="demo-simple-select-label"
                size='medium'
                style={{ minWidth: '180px', height: '60px', backgroundColor: 'white', fontSize: '1.5rem' }}
                id="demo-simple-select"
                value={weekPosition}
                onChange={(e) => setWeekPosition(e.target.value as number)}>
                {weeks.map((option, index) => (
                  <MenuItem key={index} value={index} style={{ fontSize: '1.25rem' }}>
                    {option.semana}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div
            className={styles.containerVideoMenu}
            style={{
              gap: '3rem',
              display: '',
            }}
          >
            <section className={styles.containerVideo}>
              <div className="flex justify-start text-left w-full">
                <p
                  className="m-0 title mb-2 text-[1.25rem]"
                  style={{ color: '#5F5F5F', fontWeight: 'bold' }}
                >
                  {dataMiniCurso?.titulo}
                </p>
              </div>
              {currentWeek && currentWeek.length > 0 && currentWeek[0].urlVimeoHLS && dataMiniCurso && (
                <>
                  <div className="w-[80%] my-4">
                    {!mostrarVideo ? (
                      <div
                        style={{
                          position: 'relative',
                        }}
                        className="relative"
                      >
                        <ContainerButtonPlay
                          onClick={() => {
                            setMostrarVideo(true);
                          }}
                        >
                          <img
                            src={grayPlayButton}
                            alt=""
                            width={80}
                            style={{ cursor: 'pointer' }}
                          />
                        </ContainerButtonPlay>

                        <img
                          width={'100%'}
                          height={'100%'}
                          src={ dataMiniCurso?.portada }
                          alt="portada"
                        />
                      </div>
                    ) : (
                      <VideoPlayer
                        url={ dataMiniCurso?.urlVimeoHLS }
                      />
                    )}
                  </div>
                  <div className="flex flex-col justify-center items-center">
                    <div
                      className='text-left'
                      dangerouslySetInnerHTML={{ __html: dataMiniCurso?.descripcion || '' }}
                    ></div>                   

                  </div>

                  <div
                    className="flex items-center justify-center w-full max-w-[950px]"
                    style={{
                      gap: '1rem',
                      paddingLeft: '1rem',
                      marginTop: '1.25rem',
                      marginBottom: '1.5rem',
                    }}
                  >
                    <button
                      className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 text-lg opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default"
                      disabled={ currentPosition === 0 ? true : false }
                      onClick={retrocederVideo}
                    >
                    <ArrowBackIosIcon /> Anterior
                    </button>

                    <button
                      className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 text-lg opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default`}
                      disabled={ currentPosition + 1 === currentWeek.length ? true : false }
                      onClick={avanzarVideo}
                    >
                      Siguiente <ArrowForwardIosIcon />
                    </button>
                  </div>
                </>
              )}
            </section>
            {/*//* Menú lateral */}
            <aside className={`pt-10 min-w-[20%]`}>
              <div>
                <p
                  className="fw-bold m-0"
                  style={{
                    backgroundColor: '#424242',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '1.4rem',
                  }}
                >
                  Programación
                </p>
                <div style={{ paddingLeft: '1.5rem', marginTop: '.5rem' }}>
                  {currentWeek && currentWeek.length > 0 && (
                    currentWeek?.map((item, i : number) => (
                      <div
                        key={ i }
                        className="flex items-center justify-between p-2 w-full cursor-pointer"
                        style={{
                          backgroundColor: currentPosition === i ? '#373737' : '#fff',
                          padding: '.2rem .5rem',
                          color: currentPosition === i ? 'white' : 'black',
                        }}
                      >
                        <p
                          key={ i }
                          onClick={() => {
                            setMostrarVideo(false);
                            setCurrentPosition(i);
                          }}
                          className="m-0 text-left"
                        >
                          {item.titulo}
                        </p>
                      </div>
                  )))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>

      {/* <ScrollToBottomFab /> */}

    </div>
  )
};

export default Fit12PagePC;